(() => {
  if (document.documentElement.dataset.osShopBound) return;
  document.documentElement.dataset.osShopBound = 'true';
  let ui, dialog, opener, activeProduct, activeCard, busy = false, toastTimer;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  const cardImage = card => card.querySelector('.hdt-card-product__media img, .os-infix-media img, .os-suggestion-image img');
  function init() {
    ui = document.querySelector('[data-os-shop-ui]');
    dialog = ui?.querySelector('dialog');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    dialog.addEventListener('close', () => {
      document.body.classList.remove('os-shop-dialog-open');
      opener?.focus({ preventScroll: true });
    });
    dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  }
  function notify(message, error = false) {
    const toast = ui.querySelector('[data-os-shop-toast]');
    clearTimeout(toastTimer);
    toast.dataset.error = String(error);
    toast.hidden = false;
    ui.querySelector('[data-os-shop-status]').textContent = message;
    toastTimer = setTimeout(() => { toast.hidden = true; }, 8000);
  }
  function selectedVariant() {
    return activeProduct?.variants.find(variant => String(variant.id) === dialog.querySelector('select').value);
  }
  function showVariant() {
    const variant = selectedVariant();
    dialog.querySelector('[data-os-shop-error]').textContent = '';
    dialog.querySelector('[type=submit]').disabled = !variant?.available;
    dialog.querySelector('[data-os-shop-price]').textContent = variant?.priceText || '';
    const compare = dialog.querySelector('[data-os-shop-compare]');
    compare.hidden = !variant || variant.compare <= variant.price;
    compare.textContent = variant?.compareText || '';
    const saving = dialog.querySelector('[data-os-shop-saving]');
    const percent = variant?.compare > variant?.price ? Math.floor((variant.compare - variant.price) * 100 / variant.compare) : 0;
    saving.hidden = percent <= 0;
    saving.textContent = percent > 0 ? `−${percent}%` : '';
    dialog.querySelector('[data-os-shop-shipping]').hidden = !(variant?.available && activeProduct.shippingEnabled && variant.price > activeProduct.threshold);
    const quantity = dialog.querySelector('[name=quantity]');
    quantity.min = variant?.min || 1;
    quantity.step = variant?.step || 1;
    quantity.value = variant?.min || 1;
    if (variant?.max != null) quantity.max = variant.max; else quantity.removeAttribute('max');
    const image = dialog.querySelector('[data-os-shop-image]');
    const src = variant?.image || cardImage(activeCard)?.currentSrc;
    image.hidden = !src;
    if (src) image.src = src;
    image.alt = activeProduct.title;
  }
  function openChoices(product, card, trigger) {
    activeProduct = product;
    activeCard = card;
    opener = trigger;
    const select = dialog.querySelector('select');
    while (select.options.length > 1) select.remove(1);
    select.value = '';
    product.variants.forEach(variant => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = `${variant.title} — ${variant.priceText}${variant.available ? '' : ` (${ui.dataset.soldOut})`}`;
      option.disabled = !variant.available;
      select.append(option);
    });
    dialog.querySelector('[data-os-shop-title]').textContent = product.title;
    dialog.querySelector('[data-os-shop-details]').href = product.url;
    if (product.variants.length === 1) select.value = product.variants[0].id;
    else if (product.selectedVariant) select.value = String(product.selectedVariant);
    showVariant();
    dialog.showModal();
    document.body.classList.add('os-shop-dialog-open');
    select.focus();
  }
  function cartTarget() {
    return [...document.querySelectorAll('.os-cart, .os-mobile-nav a')].find(element => {
      if (!/\/cart(?:[/?#]|$)/.test(element.href || '')) return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.top >= 0 && rect.bottom <= innerHeight;
    });
  }
  async function flyImage(source, sourceRect, src) {
    if (reducedMotion.matches || !src) return;
    const target = cartTarget();
    const end = target?.getBoundingClientRect();
    const destination = end || { left: document.dir === 'rtl' ? 22 : innerWidth - 66, top: 18, width: 44, height: 44 };
    const start = sourceRect || source?.getBoundingClientRect();
    if (!start || start.width <= 0 || start.bottom < 0 || start.top > innerHeight) return;
    const size = Math.min(start.width, start.height, 140);
    const image = document.createElement('img');
    image.className = 'os-shop-flying-image';
    image.alt = '';
    image.setAttribute('aria-hidden', 'true');
    image.src = src;
    const left = start.left + (start.width - size) / 2;
    const top = start.top + (start.height - size) / 2;
    Object.assign(image.style, { left: `${left}px`, top: `${top}px`, width: `${size}px`, height: `${size}px` });
    let loadTimer;
    try {
      await Promise.race([
        image.decode(),
        new Promise((resolve, reject) => { loadTimer = setTimeout(() => reject(new Error('Image unavailable')), 1800); })
      ]);
      clearTimeout(loadTimer);
      document.body.append(image);
      await image.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: `translate(${(destination.left - left) * .45}px,${(destination.top - top) * .4 - 60}px) scale(.7)`, opacity: .95, offset: .45 },
        { transform: `translate(${destination.left + destination.width / 2 - left - size / 2}px,${destination.top + destination.height / 2 - top - size / 2}px) scale(.12)`, opacity: 0 }
      ], { duration: 680, easing: 'cubic-bezier(.2,.6,.3,1)' }).finished;
      if (target) target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }], { duration: 260 });
    } catch { } finally { clearTimeout(loadTimer); image.remove(); }
  }
  function updateCount(cart) {
    document.querySelectorAll('hdt-cart-drawer').forEach(drawer => {
      drawer.dataset.count = cart.item_count;
    });
    document.querySelectorAll('.os-cart').forEach(link => {
      const label = link.querySelector('span')?.textContent || '';
      link.setAttribute('aria-label', `${label} (${cart.item_count})`);
      const count = link.querySelector('b');
      if (count) count.textContent = cart.item_count;
    });
    document.querySelectorAll('.os-mobile-nav a').forEach(link => {
      if (!/\/cart(?:[/?#]|$)/.test(link.href)) return;
      const label = link.querySelector('span');
      if (label) label.textContent = label.textContent.replace(/\(\d+\)/, `(${cart.item_count})`);
    });
  }
  async function add(product, variant, quantity, card, trigger, fromDialog = false) {
    if (busy || !variant?.available) return;
    busy = true;
    trigger.setAttribute('aria-busy', 'true');
    const submit = dialog.querySelector('[type=submit]');
    const source = fromDialog ? dialog.querySelector('[data-os-shop-image]') : cardImage(card);
    const sourceRect = source?.getBoundingClientRect();
    const src = source?.naturalWidth > 0 ? source.currentSrc : variant.image;
    if (fromDialog) {
      submit.disabled = true;
      submit.textContent = ui.dataset.adding;
      dialog.querySelector('select').disabled = true;
      dialog.querySelector('[name=quantity]').disabled = true;
    }
    dialog.querySelector('[data-os-shop-error]').textContent = '';
    let added = false;
    try {
      const drawer = document.querySelector('hdt-cart-drawer');
      const sectionId = drawer?.getAttribute('section-id');
      const payload = { items: [{ id: variant.id, quantity }], sections_url: location.pathname };
      if (sectionId) payload.sections = [sectionId];
      const response = await fetch(`${rootUrl()}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : ui.dataset.error);
      added = true;
      if (fromDialog) dialog.close();
      if (sectionId && result.sections?.[sectionId]) {
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { cartData: result, source: 'oscar-shop-card', actionAfterATC: 'no_action' } }));
      } else if (drawer) document.dispatchEvent(new CustomEvent('cart:reload'));
      const countUpdate = fetch(`${rootUrl()}cart.js`, { headers: { Accept: 'application/json' } }).then(response => { if (!response.ok) throw new Error(); return response.json(); }).then(updateCount).catch(() => {});
      await flyImage(source, sourceRect, src);
      await countUpdate;
      notify(ui.dataset.added);
      document.dispatchEvent(new CustomEvent('oscar:shop-added', { detail: { variantId: variant.id, quantity } }));
    } catch (error) {
      const message = added ? ui.dataset.added : error.message || ui.dataset.error;
      if (fromDialog && !added) dialog.querySelector('[data-os-shop-error]').textContent = message;
      else notify(message, !added);
    } finally {
      busy = false;
      trigger.removeAttribute('aria-busy');
      dialog.querySelector('select').disabled = false;
      dialog.querySelector('[name=quantity]').disabled = false;
      submit.disabled = !selectedVariant()?.available;
      submit.textContent = ui.dataset.add;
    }
  }
  document.addEventListener('click', event => {
    if (!ui) init();
    if (!ui) return;
    const trigger = event.target.closest('[data-os-shop-open]');
    if (trigger) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const card = trigger.closest('.os-product-cell');
      let product;
      try { product = JSON.parse(card.querySelector('[data-os-shop-product]').textContent); } catch { return; }
      if (product.requiresPlan || product.variantCount > 50) return;
      event.preventDefault();
      if (busy) return;
      if (trigger.getAttribute('aria-disabled') === 'true') { notify(ui.dataset.soldOut, true); return; }
      if (product.variants.length === 1 && product.variants[0].min === 1) add(product, product.variants[0], 1, card, trigger);
      else openChoices(product, card, trigger);
    }
    if (event.target.closest('[data-os-shop-close]') && !busy) dialog.close();
    if (event.target.closest('[data-os-shop-dismiss]')) ui.querySelector('[data-os-shop-toast]').hidden = true;
    if (event.target === dialog && !busy) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('change', event => { if (event.target.matches('[data-os-shop-select]')) showVariant(); });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-os-shop-form]')) return;
    event.preventDefault();
    if (!event.target.reportValidity()) return;
    add(activeProduct, selectedVariant(), Number(event.target.elements.quantity.value), activeCard, opener, true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
